<template>
  <div class="picker-apply-choose m-b50">
    <div class="c-3 f-18 font-b m-b25">提货方式</div>
    <div class="m-b30 flex-h">
      <div class="img-div" :class="[isSelf ? '' : 'half-opacity']" @click="chooseType(true)">
        <div
          style="height:94%"
          class="absolute-view"
          :class="[isSelf ? 'img-shadow' : 'img-hover']"
        ></div>
        <img
          style="position:relative;cursor:pointer"
          :src="require(`@/assets/picker/picker-self-${isSelf ? 'on' : 'off'}.png`)"
        />
        <div class="img-text f-18 f-b" :class="[isSelf ? 'c-3' : 'c-9']">商家配送</div>
      </div>
      <div
        v-if="!isSelf"
        class="img-div m-l25"
        :class="[isSelf ? 'half-opacity' : '']"
        @click="chooseType(false)"
      >
        <div
          style="height:94%"
          class="absolute-view"
          :class="[isSelf ? 'img-hover' : 'img-shadow']"
        ></div>
        <img
          style="position:relative;cursor:pointer"
          :src="require(`@/assets/picker/picker-org-${isSelf ? 'off' : 'on'}.png`)"
        />
      </div>
    </div>
    <!-- 自提 -->
    <div v-if="isSelf">
      <div class="c-9 m-b35 flex-h-sb-ac">
        <div class="flex-h-ac">
          <span class="f-14">提货人信息</span>
          <img class="m-l10" src="@/assets/icons/info.svg" style="width: 12px; height: 12px;" />
          <span class="f-12">请根据实际凭证信息至少填写以下一项</span>
        </div>
        <div
          v-if="dispatcherList.length > 0"
          class="f-13 link-text"
          @click="chooseDispatcherDialog = true"
        >
          历史提货人
        </div>
      </div>
      <div class="c-6 f-13 flex-h-sb-ac m-b10">
        <span class="label">姓名</span>
        <el-input
          v-model="form.dispatcherName"
          placeholder="请输入司机姓名"
          class="flex-full"
          maxlength="400"
        ></el-input>
      </div>
      <div class="c-6 f-13 flex-h-sb-ac m-b10">
        <span class="label">车牌号</span>
        <el-input
          v-model="form.dispatcherCarNo"
          placeholder="请输入司机车牌号码"
          class="flex-full"
          maxlength="400"
        ></el-input>
      </div>
      <div class="c-6 f-13 flex-h-sb-ac m-b10">
        <span class="label">身份证</span>
        <el-input
          v-model="form.dispatcherCardNo"
          placeholder="请输入司机身份证号"
          class="flex-full"
          maxlength="400"
        ></el-input>
      </div>
      <div class="c-6 f-13 flex-h-sb-ac m-b10">
        <span class="label">电话</span>
        <el-input
          v-model="form.dispatcherContact"
          placeholder="请输入司机手机号码"
          class="flex-full"
          maxlength="400"
        ></el-input>
      </div>
      <div class="c-6 f-13 flex-h-sb-ac m-b10">
        <span class="label">其他凭证</span>
        <el-input
          v-model="form.dispatcherParam"
          class="flex-full"
          placeholder="提货单号等等"
          maxlength="400"
        ></el-input>
      </div>
    </div>
    <!-- 过户 -->
    <div v-else>
      <div class="c-9 m-b20 flex-h-sb-ac">
        <div class="f-14">选择过户抬头</div>
      </div>
      <el-radio-group
        v-model="chooseOrgRadio"
        class="c-6 f-13"
        style="width: 100%"
        @change="onChangeOrgRadio"
      >
        <div
          v-for="(item, i) in orgList"
          :key="i"
          class="cell"
          :class="chooseOrgRadio === i ? 'bg-gray' : ''"
        >
          <el-radio class="cell-org p-l20" :label="i">
            {{ item.orgName }}
          </el-radio>
        </div>
      </el-radio-group>
    </div>
    <div class="c-6 f-13 b-t2-gray flex-h-ac p-t20 m-t20">
      <span class="label">提货备注</span>
      <el-input
        v-model="pickerRemark"
        class="flex-full"
        placeholder="如：规格要求、板面要求、吊费、装车顺序、提卷提板等等"
      ></el-input>
    </div>
    <el-dialog
      class="dispatcher-dialog"
      title="历史提货人"
      :visible.sync="chooseDispatcherDialog"
      width="440px"
    >
      <el-scrollbar style="height: 210px;">
        <el-radio-group
          v-model="chooseDispatcherRadio"
          class="c-6 f-13 m-b20"
          style="width: 100%;"
          @change="onChangeDispatcherRadio"
        >
          <div
            v-for="(item, i) in dispatcherList"
            :key="i"
            class="cell cell-dispatcher flex-h-ac"
            :class="chooseDispatcherRadio === i ? 'bg-gray' : ''"
            @click="onChangeDispatcherRadio(i)"
          >
            <el-radio class="p-l20" :label="i">{{ '' }}</el-radio>
            <div class="p-15 lh-20">{{ contactDispatcherInfo(item) }}</div>
          </div>
        </el-radio-group>
      </el-scrollbar>
      <span slot="footer" class="dialog-footer">
        <el-button @click="chooseDispatcherDialog = false">取消</el-button>
        <el-button type="primary" @click="dialogSubmit">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { PickerTypeCode } from '../code'

export default {
  name: 'PickerApplyChoose',
  components: {},
  props: {
    canSubmit: Object,
    subType: Number
  },
  data() {
    return {
      PickerTypeCode,
      isSelf: true, // 是否自提
      form: {
        dispatcherName: '',
        dispatcherCarNo: '',
        dispatcherContact: '',
        dispatcherCardNo: '',
        dispatcherParam: ''
      },
      pickerRemark: '', // 提单备注信息
      dispatcherList: [], // 历史提货人信息列表
      chooseDispatcherDialog: false,
      chooseDispatcherRadio: 0,
      dispatcherId: null, // 提交时上传的提货人id
      chooseOrgRadio: 0,
      chooseOrgId: null // 提交时上传的公司id
    }
  },
  computed: {
    orgList() {
      return []
      // return this.$store.state.account.orgInfoData.userOrgList.map(org => {
      //   return {
      //     orgName: org.name,
      //     id: org.id
      //   }
      // })
    },
    isDone() {
      if (this.isSelf) {
        let is = false
        for (const key in this.form) {
          if (this.form[key] !== '' && typeof this.form[key] !== 'undefined') is = true
        }
        return is
      } else {
        return this.chooseOrgId === null ? false : true
      }
    }
  },
  mounted() {},
  created() {
    this.getDispatcherList()
  },
  methods: {
    async getDispatcherList() {
      let { success, data } = await this.$get('lgcenter.getDispatchers', {
        getDispatchers: {
          mark: 2, // 1.买家 , 2.卖家
          logisticsWay: PickerTypeCode.SELLER, // 1/2.买家自提/过户 3.商家配送
          // sellerId: this.$store.getters.uid,
          sellerOrgId: this.$store.state.user.userCurrentOrg.id
        }
      })
      if (success && data[0].success && data[0].data) {
        this.dispatcherList = data[0].data
      }
    },
    async addDispatcher() {
      // 校验输入信息, 不符合替换
      this.pickerRemark = this.utf16toEntities(this.pickerRemark)
      for (const key in this.form) {
        this.form[key] = this.utf16toEntities(this.form[key])
      }
      if (this.isDone) {
        let upInsertDispatcher = {
          id: null,
          type: 3, // 商家配送类型
          ...this.form
        }
        let { data } = await this.$post('lgcenter.upInsertDispatcher', {
          upInsertDispatcher: upInsertDispatcher
        })
        if (data[0].success) {
          this.dispatcherId = data[0].id
        } else {
          this.$message.error(data[0].message)
        }
      } else {
        this.$message.error('请至少填写一项凭证信息！')
      }
    },
    chooseType(isSelf) {
      return
      // this.isSelf = isSelf
      // if (!this.isSelf) {
      //   this.chooseOrgId = this.orgList[this.chooseOrgRadio].id
      // } else {
      //   this.chooseOrgId = null
      // }
    },
    contactDispatcherInfo(item) {
      let name = !item.dispatcherName ? '' : `${item.dispatcherName}；`
      let phone = !item.dispatcherContact ? '' : `${item.dispatcherContact}；`
      let carNo = !item.dispatcherCarNo ? '' : `${item.dispatcherCarNo}；`
      let cardNo = !item.dispatcherCardNo ? '' : `${item.dispatcherCardNo}；`
      let other = !item.dispatcherParam ? '' : `${item.dispatcherParam}；`
      return name + phone + carNo + cardNo + other
    },
    onChangeOrgRadio(val) {
      this.chooseOrgId = this.orgList[val].id
    },
    onChangeDispatcherRadio(val) {
      this.chooseDispatcherRadio = val
    },
    dialogSubmit() {
      this.chooseDispatcherDialog = false
      let chooseData = this.dispatcherList[this.chooseDispatcherRadio]
      for (const key in this.form) {
        this.form[key] = !chooseData[key] ? '' : chooseData[key]
      }
    },
    // 转换表情符号及空格
    utf16toEntities(str) {
      if (str) {
        str = str.replace(/[\ud800-\udbff][\udc00-\udfff]/g, '') // 表情替换为?
        str = str.replace(/(^\s*)|(\s*$)/g, '') // 空格取消
        return str
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="less">
.dispatcher-dialog {
  .el-dialog__body {
    padding: 15px 30px 5px 30px;
  }
  .el-scrollbar__wrap {
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .el-radio {
    white-space: normal;
    margin-right: 20px;
    .el-radio__label {
      display: none;
    }
  }
}
.el-radio__label {
  font-weight: 400;
  color: #333333;
}
.el-radio__input.is-checked + .el-radio__label {
  font-weight: 400;
  color: #333333;
}
</style>

<style lang="less" scoped>
.picker-apply-choose {
  width: 650px;
  .half-opacity {
    opacity: 0.5;
  }
  .img-div {
    width: 310px;
    height: 80px;
    position: relative;
    &:hover {
      opacity: 1;
    }
    .img-text {
      position: absolute;
      top: 30px;
      left: 40px;
    }
    .img-shadow {
      box-shadow: 1px 10px 9px 0px #cccccc;
    }
    .img-hover {
      box-sizing: border-box;
      border: 2px solid transparent;
      &:hover {
        border: 2px solid #333333;
        cursor: pointer;
      }
    }
  }
  .label {
    width: 80px;
    text-align: right;
    padding-right: 10px;
  }
  .cell {
    min-height: 46px;
    .cell-org {
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      height: 46px;
      line-height: 46px;
    }
    &:hover {
      background-color: #f8f8f8;
      .edit {
        cursor: pointer;
      }
    }
  }
  .cell-dispatcher {
    &:hover {
      cursor: pointer;
    }
  }
}
</style>
